import { render, staticRenderFns } from "./SupportTooltip.vue?vue&type=template&id=935502d0&"
import script from "./SupportTooltip.vue?vue&type=script&lang=ts&"
export * from "./SupportTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports